import { memo } from 'react';
import { Hidden, Typography } from '@material-ui/core';
import { ResumeTopFoldIcon } from '@room-match/shared-ui-components';
import { getCompletionColor } from 'pages/Representatives/utils/getCompletionColor';
import {
  EditProfileMediaDocumentProgressBar,
  EditProfileMediaProgressBarContainerLarge,
} from '../../EditProfileMediaDocumentAccordion/EditProfileMediaDocumentAccordion.styles';
import {
  EditProfileMediaResumeHeaderContainer,
  EditProfileResumeProgressContainer,
} from '../EditProfileMediaResume.styles';
import { EditProfileProgressText } from '../../EditProfileSideInfo/EditProfileSideInfo.styles';
import ProgressBar from 'shared/components/ProfileProgressBar/ProgressBar';
import { getMediaCompletion } from 'pages/Representatives/utils/getMediaCompletion';

type EditProfileMediaResumeHeaderProps = {
  creditsLength: number;
};

const EditProfileMediaResumeHeader = ({ creditsLength }: EditProfileMediaResumeHeaderProps) => {
  const completeness = getMediaCompletion(creditsLength);
  return (
    <EditProfileMediaResumeHeaderContainer>
      <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
        <ResumeTopFoldIcon />
        <div>
          <Typography>Resume</Typography>
          <Typography>{creditsLength} Credits</Typography>
        </div>
      </div>
      <Hidden mdUp>
        <EditProfileMediaDocumentProgressBar
          value={completeness}
          text={`${completeness}%`}
          completeness={completeness}
        />
      </Hidden>
      <Hidden smDown>
        <EditProfileResumeProgressContainer>
          <EditProfileProgressText style={{ marginTop: 10 }} progress={completeness}>
            {completeness} % Complete
          </EditProfileProgressText>
          <EditProfileMediaProgressBarContainerLarge>
            <ProgressBar borderRadius={8} percent={completeness} completeColor={getCompletionColor(completeness)} />
          </EditProfileMediaProgressBarContainerLarge>
        </EditProfileResumeProgressContainer>
      </Hidden>
    </EditProfileMediaResumeHeaderContainer>
  );
};

export default memo(EditProfileMediaResumeHeader);
